import React, { useState, useEffect } from 'react'
import numeral from 'numeral'
import moment from 'moment'
import { Mutation, ApolloConsumer } from 'react-apollo'
import _ from 'lodash'
import {
  message, Select,
} from 'antd'
import {
  Div, P, H4, ButtonForm, Input, H5, Loading, SmallText,
} from 'konsys-ui'
import UploadFile from '../../components/common/upload'
import Container from '../../components/container'
import SummaryBox from '../../components/common/summary-detail'
import Banner from '../../images/payment-verification/banner.jpg'
import ReceiptImg from '../../images/payment-verification/receipt.png'
import VerificationImg from '../../images/payment-verification/verification.png'
import BankLogo from '../../images/payment-verification/bank.png'
import { SEARCH_PAYMENT } from '../../constants/graph/query'
import { CREATE_PAYMENT } from '../../constants/graph/mutation'
import history from '../../history'
import {
  WidthContainer, ImgBox, TableDiv, HeadWrapper, EachCell, InfoCell, CellText, SearchButton, SearchWrapper, FormWrapper,
  SummaryWrapper, ColorDiv, EachInputWrapper, HeadContent, DateTimeInputContainer, DateTimeInputWrapper, NameInputDiv,
  InputColumn, SearchInputWrapper, PriceRow, InputContainer, InputWrapper, BgContainer, SearchTitleWrapper, InputDiv,
} from './styled'
import { theme } from '../../styles/_variables'

const PcTable = () => (
  <Div display='flex' justifyContent='flex-start'>
    <Div display='flex' flexDirection='column' justifyContent='center' width='15%'>
      <TableDiv background={theme.color.primaryColor} padding='10px 0' center head>
        <P>ธนาคาร</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='10px 0' border isHeight center>
        <Div display='flex' flexDirection='column' alignItems='center'>
          <ImgBox src={BankLogo}/>
          <P style={{ color: '#6F6E6E' }}>กรุงศรี</P>
        </Div>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='20px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>PromptPay</P>
      </TableDiv>
    </Div>
    <Div display='flex' flexDirection='column' width='20%'>
      <TableDiv background={theme.color.primaryColor} padding='10px 0' center head>
        <P>หมายเลขบัญชี</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='10px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>016-1-71673-1</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='20px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>0105545093299</P>
      </TableDiv>
    </Div>
    <Div display='flex' flexDirection='column' width='12%'>
      <TableDiv background={theme.color.primaryColor} padding='10px 0' center head>
        <P>สาขา</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='10px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>บางแค</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='20px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>-</P>
      </TableDiv>
    </Div>
    <Div display='flex' flexDirection='column' width='15%'>
      <TableDiv background={theme.color.primaryColor} padding='10px 0' center head>
        <P>ประเภทบัญชี</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='10px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>ออมทรัพย์</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='20px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>-</P>
      </TableDiv>
    </Div>
    <Div display='flex' flexDirection='column' width='38%'>
      <TableDiv background={theme.color.primaryColor} padding='10px 0' center head>
        <P>ชื่อบัญชี</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='10px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>บริษัท ยูดีอาร์ อินเตอร์พริ้นท์ จำกัด</P>
      </TableDiv>
      <TableDiv background={theme.color.offWhite} padding='20px 0' border isHeight center>
        <P style={{ color: '#6F6E6E' }}>บริษัท ยูดีอาร์ อินเตอร์พริ้นท์ จำกัด</P>
      </TableDiv>
    </Div>
  </Div>
)

const MobileTable = () => (
  <Div display='flex' flexDirection='column' width='100%'>
    <TableDiv background={theme.color.primaryColor} padding='10px 20px' head>
      <P color={theme.color.primaryColor}>รายละเอียดบัญชี</P>
    </TableDiv>
    <InfoCell>
      <EachCell>
        <CellText label margin='16px 0'>ธนาคาร</CellText>
        <Div display='flex' flexDirection='column' alignItems='center'>
          <ImgBox src={BankLogo}/>
          <P>กรุงศรี</P>
        </Div>
      </EachCell>
      <EachCell width='120px'>
        <CellText label margin='16px 0 0'>หมายเลขบัญชี</CellText>
        <CellText margin='10px 0'>016-1-71673-1</CellText>
      </EachCell>
      <EachCell>
        <CellText label margin='16px 0 0'>สาขา</CellText>
        <CellText margin='10px 0'>บางแค</CellText>
      </EachCell>
      <EachCell>
        <CellText label margin='16px 0 0'>ประเภทบัญชี</CellText>
        <CellText margin='10px 0'>ออมทรัพย์</CellText>
      </EachCell>
      <EachCell width='100%'>
        <CellText label margin='16px 0 0'>ชื่อบัญชี</CellText>
        <CellText margin='10px 0'>บริษัท ยูดีอาร์ อินเตอร์พริ้นท์ จำกัด</CellText>
      </EachCell>
    </InfoCell>
    <InfoCell>
      <EachCell>
        <CellText label margin='16px 0 0'>ธนาคาร</CellText>
        <CellText margin='10px 0'>PromptPay</CellText>
      </EachCell>
      <EachCell width='120px'>
        <CellText label margin='16px 0 0'>หมายเลขบัญชี</CellText>
        <CellText margin='10px 0'>0105545093299</CellText>
      </EachCell>
      <EachCell>
        <CellText label margin='16px 0 0'>สาขา</CellText>
        <CellText margin='10px 0'>-</CellText>
      </EachCell>
      <EachCell>
        <CellText label margin='16px 0 0'>ประเภทบัญชี</CellText>
        <CellText margin='10px 0'>-</CellText>
      </EachCell>
      <EachCell width='100%'>
        <CellText label margin='16px 0 0'>ชื่อบัญชี</CellText>
        <CellText margin='10px 0'>บริษัท ยูดีอาร์ อินเตอร์พริ้นท์ จำกัด</CellText>
      </EachCell>
    </InfoCell>
  </Div>
)

const priceValidator = price => /^\d*\.?\d*$/.test(price)
const dateTimeValidator = datetime => /^\d{1,4}$/.test(datetime)

const InputWithBottomLabel = ({
  label, width, margin, onChangeAllVariables, keyValue, inputValue, limit, type,
}) => (
  <InputColumn margin={margin}>
    <Input
      width={width}
      value={inputValue}
      onChange={(e) => {
        if ((dateTimeValidator(e.target.value) && parseInt(e.target.value, 10) <= limit && parseInt(e.target.value, 10) >= 0) || e.target.value === '') {
          onChangeAllVariables(keyValue, e.target.value)
        }
      }}
      onBlur={() => {
        if (type === 'day' || type === 'month') {
          if (inputValue === '' || parseInt(inputValue, 10) <= 0) {
            onChangeAllVariables(keyValue, '1')
          }
        } else if (type === 'year' && (inputValue === '' || parseInt(inputValue, 10) <= 0)) {
          onChangeAllVariables(keyValue, moment().format('YYYY'))
        }
      }}
    />
    <SmallText style={{ color: '#6F6E6E' }}>{label}</SmallText>
  </InputColumn>
)

const VerificationHead = ({
  success, id, isMobileXL,
}) => (
  <WidthContainer>
    <HeadWrapper>
      <Div className='imgdiv' margin='0 40px 0 0' moreStyle={{
        flexBasis: '20%',
      }}>
        <ImgBox width={success ? '100%' : '230px'} src={success ? ReceiptImg : VerificationImg} />
      </Div>
      <HeadContent successHeight={success}>
        {/* TODO: Change font color here */}
        <Div>
          {
            success
              ? <H5 display='block' color='#6F6E6E'>คำร้องขอใบเสนอราคาหมายเลข {id} ได้รับการยืนยันการชำระเงินแล้ว กรุณารอเจ้าหน้าที่ตรวจสอบการชำระเงินสักครู่ เราจะดำเนินการทันทีเมื่อการตรวจสอบเสร็จสิ้น</H5>
              : <H5 display='block' color='#6F6E6E'>หลังจากได้รับใบเสนอราคาแล้ว คุณสามารถชำระเงินผ่านบัญชีธนาคารด้านล่าง และทำการยืนยันการชำระเงิน
               โดยการระบุหมายเลขอ้างอิง ตรวจสอบข้อมูล และแนบหลักฐานการชำระเงินผ่านแบบฟอร์มด้านล่าง</H5>
          }
        </Div>
        <Div margin='32px 0 0' textAlign='center'>
          {
            success
              ? <ButtonForm inverse color={theme.color.secondaryColor} buttonStyle="round" text='กลับสู่หน้าแรก' onClick={() => history.push('/')}/>
              : isMobileXL
                ? <MobileTable/>
                : <PcTable/>
          }
        </Div>
      </HeadContent>
    </HeadWrapper>
  </WidthContainer>
)

const VerificationForm = ({
  onChangeSuccess, allVariables, onChangeAllVariables, refId, onChangeRefId, isMobileView,
}) => {
  const [queryData, setQueryData] = useState({
    quantity: '',
    quotationId: '',
    refId: '',
    createdAt: '',
    totalPrice: '',
    name: '',
    success: false,
    loading: '',
    error: '',
  })

  const onRemoveFileList = (fileName, name) => {
    const newData = { ...allVariables }
    const newFileList = [...allVariables[name]]
    _.remove(newFileList, v => v.name === fileName)
    newData[name] = newFileList
    onChangeAllVariables(name, newData[name])
  }

  const onUploadFileList = (fileList, name) => {
    const newData = { ...allVariables }
    const newFileList = [...allVariables[name]]
    if (fileList.length >= 1) {
      Object.keys(fileList).forEach((v) => {
        if (v !== 'length') {
          newFileList.push(fileList[v])
        }
      })
    }
    newData[name] = newFileList
    onChangeAllVariables(name, newData[name])
  }

  return (
  <ApolloConsumer>
    {payment => (
      <WidthContainer flex justifyContent='center'>
        <FormWrapper>
          <SearchWrapper>
            <SearchTitleWrapper><H4 color={theme.color.primaryColor}>หมายเลขคำร้องขอใบเสนอราคา</H4></SearchTitleWrapper>
            <SearchInputWrapper>
              <Input
                width='75%'
                margin='0 10px 0 0'
                onChange={e => onChangeRefId(e.target.value)}
              />
              <Div>
                <SearchButton
                  inverse
                  small
                  color={theme.color.secondaryColor}
                  icon='far fa-search'
                  buttonStyle="round"
                  text='ค้นหา'
                  onClick={async () => {
                    const { data, loading, error } = await payment.query({
                      query: SEARCH_PAYMENT,
                      variables: { refId },
                      fetchPolicy: 'network-only',
                    })
                    if (data && data.findByRefId && !data.findByRefId.success) {
                      message.error(data.findByRefId.message)
                      setQueryData({
                        ...data.findByRefId.foundRequest,
                        success: data.findByRefId.success,
                        loading,
                        error,
                      })
                    } else {
                      setQueryData({
                        ...data.findByRefId.foundRequest,
                        success: data.findByRefId.success,
                        loading,
                        error,
                      })
                    }
                  }}
                />
              </Div>
            </SearchInputWrapper>
          </SearchWrapper>
          {
            queryData.error
              ? null
              : queryData.loading
                ? <Loading/>
                : queryData.success
            && <SummaryWrapper>
              <SummaryBox
                title={'ผลการค้นหา'}
                dataList={[
                  { title: 'หมายเลขคำร้องขอใบเสนอราคา', name: 'p_id', value: queryData.refId },
                  { title: 'วันที่ / เวลา', name: 'p_date', value: queryData.createdAt },
                  { title: 'ชื่อบรรจุภัณฑ์', name: 'p_name', value: queryData.name },
                  { title: 'จำนวน (ชิ้น)', name: 'p_amount', value: queryData.quantity },
                ]}
              />
              <PriceRow>
                <ColorDiv width='45%' primaryColor><H5 color={theme.color.offWhite}>ราคา (บาท)</H5></ColorDiv>
                <ColorDiv width='65%' reverse><H5>{numeral(queryData.totalPrice).format('0,0.00')}</H5></ColorDiv>
              </PriceRow>
              <InputContainer>
                <ColorDiv width='100%' primaryColor><H4 color={theme.color.offWhite}>รายละเอียดการชำระเงิน</H4></ColorDiv>
                <InputWrapper>
                  <EachInputWrapper>
                    <Div flexBasis='50%' display='flex' alignItems='center'>
                      <H5 style={{ color: '#6F6E6E' }}>ธนาคาร *</H5>
                    </Div>
                    <InputDiv flexBasis='32%' textAlign='right'>
                      <Select
                        showSearch
                        style={{ width: isMobileView ? '100%' : '200px', fontSize: theme.fonts.size.normal }}
                        placeholder="กรุณาเลือกวิธีชำระเงิน"
                        optionFilterProp="children"
                        onChange={e => onChangeAllVariables('paymentMethod', e)}
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                      >
                        <Select.Option value="bank">ธนาคารกรุงศรี</Select.Option>
                        <Select.Option value="promptPay">PromptPay</Select.Option>
                      </Select>
                    </InputDiv>
                  </EachInputWrapper>
                  <EachInputWrapper>
                    <Div flexBasis='50%' display='flex' alignItems='center'>
                      <H5 style={{ color: '#6F6E6E' }}>จำนวนเงิน (บาท) *</H5>
                    </Div>
                    <InputDiv flexBasis='32%' textAlign='right'>
                      <Input width='100%' value={allVariables.amount} onChange={(e) => {
                        if (priceValidator(e.target.value)) {
                          onChangeAllVariables('amount', e.target.value)
                        }
                      }}/>
                    </InputDiv>
                  </EachInputWrapper>
                  <EachInputWrapper>
                    <Div flexBasis='40%' display='flex' alignItems='center' margin='0 0 10px'>
                      <H5 style={{ color: '#6F6E6E' }}>วันที่ / เวลา *</H5>
                    </Div>
                    <DateTimeInputContainer>
                      <DateTimeInputWrapper isStart width='65%'>
                        <InputWithBottomLabel
                          width={isMobileView ? '100%' : '35px'}
                          label='วัน'
                          margin='0 4px 0 0'
                          onChangeAllVariables={onChangeAllVariables}
                          keyValue='date'
                          inputValue={allVariables.date}
                          limit={31}
                          isMobileView={isMobileView}
                          type='day'
                        />
                        /
                        <InputWithBottomLabel
                          width={isMobileView ? '100%' : '35px'}
                          label='เดือน'
                          margin='0 4px'
                          onChangeAllVariables={onChangeAllVariables}
                          keyValue='month'
                          inputValue={allVariables.month}
                          limit={12}
                          isMobileView={isMobileView}
                          type='month'
                        />
                        /
                        <InputWithBottomLabel
                          width={isMobileView ? '100%' : '52px'}
                          label='ปี'
                          margin='0 0 0 4px'
                          onChangeAllVariables={onChangeAllVariables}
                          keyValue='year'
                          inputValue={allVariables.year}
                          limit={10000}
                          isMobileView={isMobileView}
                          type='year'
                        />
                      </DateTimeInputWrapper>
                      <DateTimeInputWrapper width='33%'>
                        <InputWithBottomLabel
                          width={isMobileView ? '100%' : '35px'}
                          label='ชม.'
                          margin='0 4px 0 0'
                          onChangeAllVariables={onChangeAllVariables}
                          keyValue='hour'
                          inputValue={allVariables.hour}
                          limit={24}
                          isMobileView={isMobileView}
                        />
                        :
                        <InputWithBottomLabel
                          width={isMobileView ? '100%' : '35px'}
                          label='นาที'
                          margin='0 0 0 4px'
                          onChangeAllVariables={onChangeAllVariables}
                          keyValue='minute'
                          inputValue={allVariables.minute}
                          limit={59}
                          isMobileView={isMobileView}
                        />
                      </DateTimeInputWrapper>
                    </DateTimeInputContainer>
                  </EachInputWrapper>
                  <EachInputWrapper>
                    <Div flexBasis='40%' display='flex' alignItems='center'>
                      <H5 style={{ color: '#6F6E6E' }}>ชื่อบัญชีผู้ชำระเงิน *</H5>
                    </Div>
                    <NameInputDiv flexBasis='47%' textAlign='right' >
                      <Input width='100%' onChange={e => onChangeAllVariables('name', e.target.value)}/>
                    </NameInputDiv>
                  </EachInputWrapper>
                  <Div margin='24px 0'>
                    <H4 display='block' margin='0 0 8px' bold color={theme.color.primaryColor}>แนบไฟล์หลักฐานการชำระเงิน *</H4>
                    <UploadFile
                      list={allVariables.evidenceFiles}
                      id='uploadFileId'
                      multiple
                      onChange={(fileList) => {
                        let upload = false
                        const allowFileType = ['jpg', 'jpeg', 'png', 'pdf']
                        for (let i = 0; i < fileList.length; i += 1) {
                          const splitName = fileList[i].name.split('.')
                          if (!_.includes(allowFileType, splitName[splitName.length - 1].toLowerCase())
                          || (allVariables.evidenceFiles.length > 0 && !_.isUndefined(_.find(allVariables.evidenceFiles, d => d.name === fileList[i].name)))) {
                            upload = false
                            break
                          } else {
                            upload = true
                          }
                        }
                        if (upload) {
                          onUploadFileList(fileList, 'evidenceFiles')
                        } else {
                          message.error('สามารถอัพโหลดได้เฉพาะไฟล์ jpg, jpeg, png, pdf และไม่สามารถอัพรูปซ้ำได้')
                        }
                      }}
                      onRemoveFile={fileName => onRemoveFileList(fileName, 'evidenceFiles')}
                      fileType="image/*, .pdf"
                    />
                  </Div>
                </InputWrapper>
              </InputContainer>
              <Mutation
                mutation={CREATE_PAYMENT}
              >
              {
                doCreatePayment => (
                  <Div margin='16px 0 32px' textAlign='center'>
                    <ButtonForm
                      disabled={allVariables.paymentMethod === ''
                        || allVariables.amount === ''
                        || allVariables.date === ''
                        || allVariables.month === ''
                        || allVariables.year === ''
                        || allVariables.minute === ''
                        || allVariables.hour === ''
                        || allVariables.name === ''
                        || _.isEmpty(allVariables.evidenceFiles)}
                      inverse
                      color={theme.color.secondaryColor}
                      buttonStyle="round"
                      text='ยืนยันการชำระเงิน'
                      onClick={() => {
                        doCreatePayment({
                          variables: {
                            ...allVariables,
                            quotationId: queryData.quotationId,
                            amount: parseFloat(allVariables.amount),
                          },
                        }).then((res) => {
                          window.scrollTo(0, 0)
                          if (!res.loading && !_.isUndefined(res.data)) {
                            if (!res.data.createPayment.success) {
                              message.error(res.data.createPayment.message)
                            } else {
                              message.success(res.data.createPayment.message)
                              onChangeSuccess(res.data.createPayment.success)
                            }
                          }
                        })
                      }}
                    />
                  </Div>
                )
              }
              </Mutation>
            </SummaryWrapper>
          }
        </FormWrapper>
      </WidthContainer>
    )}
  </ApolloConsumer>
  )
}

const PaymentVerification = () => {
  const [success, setSuccess] = useState(false)
  const [refId, setRefId] = useState('')
  const [allVariables, setAllVariables] = useState({
    quotationId: '',
    amount: '',
    date: '',
    month: '',
    year: '',
    hour: '',
    minute: '',
    name: '',
    evidenceFiles: [],
    paymentMethod: '',
  })
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 375)
  const [isMobileXL, setIsMobileXL] = useState(window.innerWidth <= 570)

  const screenSizeHandler = () => setIsMobileView(window.innerWidth <= 375)
  const screenSizeHandler2 = () => setIsMobileXL(window.innerWidth <= 570)

  useEffect(() => {
    window.addEventListener('resize', screenSizeHandler)
    window.addEventListener('resize', screenSizeHandler2)
    return () => {
      window.removeEventListener('resize', screenSizeHandler)
      window.removeEventListener('resize', screenSizeHandler2)
    }
  }, [])

  const onChangeSuccess = (value) => {
    setSuccess(value)
  }

  const onChangeRefId = (value) => {
    setRefId(value)
  }

  const onChangeAllVariables = (key, value) => {
    setAllVariables({
      ...allVariables,
      [key]: value,
    })
  }

  return (
    <Container
      header={{
        type: 'title',
        img: Banner,
        title: 'ยืนยันการชำระเงิน',
      }}
    >
      <BgContainer>
        <VerificationHead success={success} id={refId} isMobileView={isMobileView} isMobileXL={isMobileXL}/>
        {
          !success && <VerificationForm
            onChangeSuccess={onChangeSuccess}
            allVariables={allVariables}
            onChangeAllVariables={onChangeAllVariables}
            refId={refId}
            onChangeRefId={onChangeRefId}
            isMobileView={isMobileView}
          />
        }
      </BgContainer>
    </Container>
  )
}

export default PaymentVerification



// WEBPACK FOOTER //
// ./src/pages/payment-verification-page/index.jsx